module.exports = __webpack_public_path__ + "static/media/perfume.92ef6ab7.jpg";